import { anyTypeToString, stringToData } from "./local_storage_helpers";
export class WebSessionStorageWorker {
  public sessionStorageSupported: boolean;
  constructor() {
    this.sessionStorageSupported = this.canWriteStorage();
  }

  public canWriteStorage() {
    if (!window.sessionStorage) {
      return false;
    }
    try {
      window.sessionStorage.setItem("@@", "test");
      window.sessionStorage.removeItem("@@");
      return true;
    } catch (e) {
      return false;
    }
  }

  public set(key: string, data: any) {
    if (this.sessionStorageSupported) {
      const dataStr: string = anyTypeToString(data);
      sessionStorage.setItem(key, dataStr);
      return this.get(key);
    }
  }

  public get(key: string) {
    if (this.sessionStorageSupported) {
      const data: any = sessionStorage.getItem(key);
      return stringToData(data);
    } else {
      return null;
    }
  }

  public has(key: string) {
    return this.sessionStorageSupported && this.get(key) ? true : false;
  }

  public remove(key: string) {
    this.sessionStorageSupported && sessionStorage.removeItem(key);
  }

  public clear() {
    this.sessionStorageSupported && sessionStorage.clear();
  }
}
export default new WebSessionStorageWorker();
